import { BreakpointObserver } from '@angular/cdk/layout';
import {
   Component,
   Input,
   OnChanges,
   OnInit,
   SimpleChanges,
} from '@angular/core';
import { TypesenseService } from 'src/app/shared/services/typesense.service';

@Component({
    selector: 'app-stock-news',
    templateUrl: './stock-news.component.html',
    styleUrls: ['./stock-news.component.scss'],
    standalone: false
})
export class StockNewsComponent implements OnInit, OnChanges {
   public news: any;
   public showNews: boolean = false;
   isMobile: boolean = false;
   newsLoader: boolean = true;

   @Input() ticker: string | undefined;
   @Input() tickers: string[] | undefined;

   constructor(
      private typesenseService: TypesenseService,
      private observer: BreakpointObserver
   ) {}

   ngOnChanges(changes: SimpleChanges): void {
      if (this.ticker) {
         this.stocksNew(this.ticker);
      }
   }

   ngOnInit(): void {
      this.observer.observe('(max-width: 992px)').subscribe(result => {
         this.isMobile = result.matches
      });
   }

   trackByNewsId(index: number, news: any) { 
      return news.Id;
   }

   private stocksNew(ticker: string) {
      this.newsLoader = true
      this.typesenseService.getCompanyNews(ticker).then((data: any) => {
         this.news = data.News;
      }).catch((error: any) => {
         console.log(error);
      }).finally(() => {
         this.newsLoader = false;
      });
   }

   getFilteredNews() {
      if(this.showNews) {
         return this.news
      } else {
         return this.news.slice(0, 6)
      }
   }

   formattedDate(date: any): Date {
      return new Date(date * 1000);
   }
}
